var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgChevronUp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04998 14.8349C7.23734 15.0212 7.49079 15.1257 7.75498 15.1257C8.01916 15.1257 8.27262 15.0212 8.45998 14.8349L12.05 11.2949L15.59 14.8349C15.7773 15.0212 16.0308 15.1257 16.295 15.1257C16.5592 15.1257 16.8126 15.0212 17 14.8349C17.0937 14.742 17.1681 14.6314 17.2189 14.5095C17.2696 14.3877 17.2958 14.257 17.2958 14.1249C17.2958 13.9929 17.2696 13.8622 17.2189 13.7404C17.1681 13.6185 17.0937 13.5079 17 13.4149L12.76 9.17494C12.667 9.08121 12.5564 9.00682 12.4346 8.95605C12.3127 8.90528 12.182 8.87914 12.05 8.87914C11.918 8.87914 11.7873 8.90528 11.6654 8.95605C11.5435 9.00682 11.4329 9.08121 11.34 9.17494L7.04998 13.4149C6.95625 13.5079 6.88186 13.6185 6.83109 13.7404C6.78032 13.8622 6.75418 13.9929 6.75418 14.1249C6.75418 14.257 6.78032 14.3877 6.83109 14.5095C6.88186 14.6314 6.95625 14.742 7.04998 14.8349Z",
    fill: "#484848"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ChevronUp.246183c6.svg";
export { ForwardRef as ReactComponent };